import React, { useState } from 'react';
import { ColorMatchSidebar } from './colorMatchSidebar';

interface ColorMatchButtonProps {
  productId: number;
}

export const ColorMatchButton: React.FC<ColorMatchButtonProps> = ({ productId }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="blueButtonOutline color-match-button"
        onClick={() => setIsOpen(true)}
        aria-label="Open Color Match Tool"
      >
        <svg style={{ width: 26 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
          <path fill="#fddd56" d="M27,5c-2.9-2.9-6.8-4.5-11-4.5v7c2.3,0,4.4,0.9,6,2.5s2.5,3.8,2.5,6h7C31.5,11.9,29.9,7.9,27,5z" />
          <path fill="#70cadb" d="M5,5c-2.9,2.9-4.5,6.8-4.5,11h7c0-2.3,0.9-4.4,2.5-6s3.8-2.5,6-2.5v-7C11.9,0.5,7.9,2.1,5,5z" />
          <path fill="#b9d34c" d="M10,22c-1.6-1.6-2.5-3.8-2.5-6h-7c0,4.1,1.6,8.1,4.5,11s6.8,4.5,11,4.5v-7C13.7,24.5,11.6,23.6,10,22z" />
          <path fill="#ee654b" d="M24.5,16c0,2.3-0.9,4.4-2.5,6s-3.8,2.5-6,2.5v7c4.1,0,8.1-1.6,11-4.5s4.5-6.8,4.5-11H24.5z" />
          <path fill="#9e61a4" d="M16,0.5v7c-2.3,0-4.4,0.9-6,2.5L5,5C7.9,2.1,11.9,0.5,16,0.5z" />
          <path fill="#70cadb" d="M10,10c-1.6,1.6-2.5,3.8-2.5,6h-7c0-4.1,1.6-8.1,4.5-11L10,10z" />
          <path fill="#55bb8c" d="M10,22l-5,5c-2.9-2.9-4.5-6.8-4.5-11h7C7.5,18.3,8.4,20.4,10,22z" />
          <path fill="#b9d34c" d="M16,24.5v7c-4.1,0-8.1-1.6-11-4.5l4.9-5C11.6,23.6,13.7,24.5,16,24.5z" />
          <path fill="#ed4569" d="M27,27c-2.9,2.9-6.8,4.5-11,4.5v-7c2.3,0,4.4-0.9,6-2.5L27,27z" />
          <path fill="#ee654b" d="M31.5,16c0,4.1-1.6,8.1-4.5,11l-5-5c1.6-1.6,2.5-3.8,2.5-6H31.5z" />
          <path fill="#f8a839" d="M31.5,16h-7c0-2.3-0.9-4.4-2.5-6l5-5C29.9,7.9,31.5,11.9,31.5,16z" />
          <path fill="#fddd56" d="M27,5l-5,5c-1.6-1.6-3.8-2.5-6-2.5v-7C20.1,0.5,24.1,2.1,27,5z" />
        </svg>
        &nbsp; Color Match Tool
      </button>

      {isOpen && <ColorMatchSidebar productId={productId} isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  );
};
